import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedOctNoiseReductionNr = reactify('zui-icon-med-oct-noise-reduction-nr');
